import { useLayoutEffect, useRef, useState } from 'react';

export const useHeaderObserver = () => {
  const ref = useRef<HTMLElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const height =
          entry.borderBoxSize[0]?.blockSize ||
          entry.target.getBoundingClientRect().height;
        // We only update if the height is > 0 (meaning the header is visible)
        if (height > 0) {
          setHeaderHeight(height);
          document.documentElement.style.setProperty(
            '--active-header-height',
            `${height}px`,
          );
        }
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, setHeaderHeight]);

  return {
    ref,
    headerHeight,
  };
};
